import React, { Component } from "react";
import MailbackRouter from "./mailBackRoutes";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import Image from "../../Image";

const MAILBACK_URL = `/mailBackRequest`;

export default class MailBackComponent extends Component {
  render() {
    return (
      <div>
        <MailbackRouter />
      </div>
    );
  }
}

export class MailBackBreadCrumb extends Component {
  render() {
    const { name } = this.props;
    return (
      <div className="tab-breadcrumbs-container" style={{ marginTop: 0 }}>
        <Breadcrumbs
          separator={<NavigateNextIcon fontSize="small" />}
          aria-label="Breadcrumb"
        >
          <div className="flex-for-settings">
            <Image
              src={"/images/bajaj_web-page-home.svg"}
              alt="web-page-home"
              style={{ height: 20, marginRight: 10 }}
            />
            <div
              onClick={() =>
                this.props.history.push(MAILBACK_URL + "/investor")
              }
              className="breadcrumbs-unselect-label"
            >
              Mailback Types
            </div>
          </div>

          <div
            color="inherit"
            className="breadcrumbs-unselect-label"
            onClick={() =>
              this.props.history.push({
                pathname: MAILBACK_URL + "/investor/investor-selection",
                state: !!this.props.investorData
                  ? {
                      name:
                        !!name && name === "Mail Back SOA"
                          ? "mailBackSoa"
                          : name === "Consolidated Account Statment"
                          ? "consolidated"
                          : name === "ELSS Account Statement"
                          ? "ELSS"
                          : name === "CAN Based Account Statement"
                          ? "CAN"
                          : name === "Capital Gains Account Statement"
                          ? "CGS"
                          : name === "Grandfathering Account Statement"
                          ? "GAS"
                          : name === "Networth Report"
                          ? "Networth"
                          : "Networth",
                      investorData: this.props.investorData,
                    }
                  : {
                      name:
                        !!name && name === "Mail Back SOA"
                          ? "mailBackSoa"
                          : name === "Consolidated Account Statment"
                          ? "consolidated"
                          : name === "ELSS Account Statement"
                          ? "ELSS"
                          : name === "CAN Based Account Statement"
                          ? "CAN"
                          : name === "Capital Gains Account Statement"
                          ? "CGS"
                          : name === "Grandfathering Account Statement"
                          ? "GAS"
                          : name === "Networth Report"
                          ? "Networth"
                          : "Networth",
                    },
              })
            }
          >
            Investors Selection
          </div>
          <div className="transaction-summary-label">{this.props.name}</div>
        </Breadcrumbs>
      </div>
    );
  }
}
